<script setup lang="ts">
import MaintenanceModeFields from '@/components/maintenanceMode/MaintenanceModeFields.vue';
import { UserCatalogDto } from '@/api/generator';
import { NotificationMessage } from '@/components/notifications/types';
import { useTranslation } from 'i18next-vue';
import type { DeepReadonly } from 'vue';
import { computed } from 'vue';
import { UpdateType } from '@/views/UpdateView/components/UpdateWizard.vue';
import { useSystemStore } from '@/stores/systemStore.ts';

const { t } = useTranslation();

const props = defineProps<{
  type: UpdateType;
  exceptionNotification?: NotificationMessage;
  notificationMessage?: NotificationMessage;
  loggedInUsers?: UserCatalogDto[] | DeepReadonly<UserCatalogDto[]>;
}>();
const { type } = props;

defineEmits(['submit']);

const systemStore = useSystemStore();

const text = computed(() => {
  switch (type) {
    case 'update':
      return {
        header: t('UpdateUpgradeInformationStepHeader'),
        maintenanceHeader: t('UpdateUpgradeInformationStepMaintenanceHeader'),
        maintenanceMessage: t('UpdateInformationStepMaintenanceMsg'),
        maintenanceWarning: t('UpdateUpgradeInformationStepMaintenanceWarning'),
      };
    case 'upgrade':
      return {
        header: t('UpdateUpgradeInformationStepHeader'),
        maintenanceHeader: t('UpdateUpgradeInformationStepMaintenanceHeader'),
        maintenanceMessage: t('UpgradeInformationStepMaintenanceMsg'),
        maintenanceWarning: t('UpdateUpgradeInformationStepMaintenanceWarning'),
      };
    default:
      throw new Error(`Unknown Update Type ${type}`);
  }
});
</script>

<template>
  <h2 class="mb-8 mt-5 on-off-white">
    {{ $t('SecurityCheck.Title') }}
  </h2>
  <p class="text-pre-line my-5">
    {{ $t('SecurityCheck.Message') }}
  </p>

  <template v-if="!systemStore.maintenanceModeInfo">
    <h3 class="on-off-white">{{ text.maintenanceHeader }}</h3>
    <p>{{ text.maintenanceMessage }}</p>
    <v-alert class="mt-5 mb-7" type="warning" :text="text.maintenanceWarning" variant="tonal" />
  </template>

  <MaintenanceModeFields
    class="mt-12"
    passwordFieldName="password"
    ignoreLoggedInUsersFieldName="ignoreLoggedInUsers"
    :exceptionNotification="exceptionNotification"
    :notificationMessage="notificationMessage"
    :loggedInUsers="loggedInUsers"
    :onPasswordEnter="() => $emit('submit')"
  />
</template>
